import { lightColors, darkColors, ColorTokens } from './colors';
import { lightShadows, darkShadows, ShadowTokens } from './shadows';
import { spacing } from './spacing';
import { radii } from './radii';
import { typography } from './typography';
import { motion } from './motion';

export type ThemeMode = 'light' | 'dark';

export type Tokens = {
  mode: ThemeMode;
  colors: ColorTokens;
  shadows: ShadowTokens;
  spacing: typeof spacing;
  radii: typeof radii;
  typography: typeof typography;
  motion: typeof motion;
};

export const lightTokens: Tokens = {
  mode: 'light',
  colors: lightColors,
  shadows: lightShadows,
  spacing,
  radii,
  typography,
  motion,
};

export const darkTokens: Tokens = {
  mode: 'dark',
  colors: darkColors,
  shadows: darkShadows,
  spacing,
  radii,
  typography,
  motion,
};

export const getTokens = (mode: ThemeMode): Tokens =>
  mode === 'dark' ? darkTokens : lightTokens;

export * from './colors';
export * from './shadows';
export { spacing, radii, typography, motion };
